import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { token } from "@atlaskit/tokens";

import { JiraOverlayTemplate } from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { FeatureExposed } from "@/utils/feature-exposed";

import { CreateASiteHeading } from "../../../components";

export const LoggedInJiraNewUser = () => (
    <FeatureExposed
        experimentKey="jfind-1565-sign-up-flow-overlay"
        group="Test"
    >
        <JiraOverlayTemplate size="sm">
            <div css={containerCss}>
                <div css={headerGroupCss}>
                    <h1 css={headerCss}>
                        <span css={accentImageSpanCss}>
                            <CreateASiteHeading />
                        </span>
                    </h1>
                    <p css={headerCss}>
                        <FormattedMessage
                            id="siteActivation.loggedInJira.newUser"
                            defaultMessage="Sites are the shared space where people organize teams, work, and projects."
                        />
                    </p>
                </div>
                <SiteActivation />
            </div>
        </JiraOverlayTemplate>
    </FeatureExposed>
);

const containerCss = css({
    display: "flex",
    flexDirection: "column"
});

const headerGroupCss = css({
    display: "grid",
    gap: token("space.100")
});

const headerCss = css({
    margin: 0,
    textAlign: "center"
});

const accentImageSpanCss = css({
    position: "relative"
});
